import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./examMarkEntry.module.css";
import { FaStar, FaUser } from "react-icons/fa";
import BlobImage from "../../../components/BlobImage/BlobImage";
import AxiosInstance, {
  IMAGE_BASE_URL,
  TokenService,
} from "../../../services/Api";
import {
  CustomButton,
  CustomDropdown,
  CustomTextInput,
} from "../../../components";
import moment from "moment";
import PopupModal from "../../../components/PopupModal/PopupModal";

function ViewExamMarkEntry() {
  const navigate = useNavigate();
  const location = useLocation();
  const { CLASSID, SECTION, SUBJECTID, MODEOFEXAM, EXAMNAME } =
    location.state || {};
  const { translations } = useSelector((state) => state.language);
  const user = TokenService.getUser();
  const clientData = user?.client_data[0] || {};
  const client_id = clientData?.client_id || "";
  const school_id = clientData?.school_id || "";
  const staff_id = clientData?.master_id;
  const userId = user?.id || 0;
  const academic_year_id = clientData?.academic_year_id || "";
  const [modalState, setModalState] = useState({
    open: false,
    type: "success", // "success" | "error"
    message: "",
    redirectPath: "",
  });
  const [examData, setExamData] = useState([]);
  const [classDetails, setClassDetails] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

const handleMarkChange = (studentId, value) => {
  // Allow empty value for clearing
  if (value === "") {
    setExamData((prev) =>
      prev.map((student) =>
        student.student_id === studentId
          ? { ...student, marks: value }
          : student,
      ),
    );
    return;
  }

  // Convert to number for validation
  const numValue = Number(value);

  // Check if it's a valid number
  if (isNaN(numValue)) {
    return;
  }

  // Check for negative numbers
  if (numValue < 0) {
    setModalState({
      open: true,
      type: "error",
      message: "Marks cannot be negative",
      redirectPath: "",
    });
    return;
  }

  // Check if exceeding max marks
  if (numValue > classDetails.max_marks) {
    setModalState({
      open: true,
      type: "error",
      message: `Marks cannot exceed ${classDetails.max_marks}`,
      redirectPath: "",
    });
    return;
  }

  // Valid mark - update the state
  setExamData((prev) =>
    prev.map((student) =>
      student.student_id === studentId
        ? { ...student, marks: value }
        : student,
    ),
  );
  
  // Clear any previous error for this student
  setErrors((prev) => ({ ...prev, [studentId]: "" }));
};

  useEffect(() => {
    fetchViewMarkEntry();
  }, [CLASSID, SECTION, SUBJECTID, MODEOFEXAM, EXAMNAME]);

  const fetchViewMarkEntry = async () => {
    setLoading(true);
    try {
      const payload = {
        school_id: parseInt(school_id),
        staff_id: staff_id,
        class_id: CLASSID,
        section_id: SECTION,
        subject_id: SUBJECTID,
        config_id: EXAMNAME,
        mode_exam: MODEOFEXAM,
        // school_id: parseInt(school_id),
        // staff_id: 5,
        // class_id: 59,
        // section_id: "B",
        // subject_id: 20,
        // config_id: 7,
        // mode_exam: "theory"
      };
      const response = await AxiosInstance.post(
        `/exam/examMarkEntry/view`,
        payload,
      );
      if (response?.data?.status) {
        setClassDetails(response.data.data);
        const examData = response.data.data.students || [];
        setExamData(examData);
      } else {
        setExamData([]);
      }
    } catch (error) {
      console.error("Error fetching exam config list:", error);
    } finally {
      setLoading(false);
    }
  };
  const validateForm = () => {
    const newErrors = {};
    return newErrors;
  };

  const handleDraft = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();

    setErrors(validationErrors);
    const marksDetails = examData.map((student) => ({
      id: student.id,
      student_id: student.student_id,
      marks: Number(student.marks) || 0, // convert to number
    }));

    // if (Object.keys(validationErrors).length === 0) {
    const payload = {
      client_id: client_id,
      academic_id: academic_year_id,
      staff_id: staff_id,
      config_id: classDetails.examtype || "",
      school_id: school_id,
      class_id: classDetails.class_id || "",
      section_id: classDetails.section_id || "",
      subject_id: classDetails.subject_id || "",
      modeof_exam: classDetails.modeof_exam || "",
      campus_exam_schedule_id: classDetails.campus_exam_schedule_id,
      exam_date: classDetails.exam_date,
      marks_details: marksDetails,
      min_marks: classDetails.min_marks,
      max_marks: classDetails.max_marks,
      is_verify: 0,
      isActive: 1,
      updated_by: userId,
    };
    const response = await AxiosInstance.put(
      `/exam/examMarkEntry/update`,
      payload,
    );
    if (response.data?.status) {
      setModalState({
        open: true,
        type: "success",
        message: response.data?.message || "Mark Entry created successfully",
        redirectPath: "/user/exams/marks",
      });
    } else {
      setModalState({
        open: true,
        type: "error",
        message: response?.data?.message || "Something went wrong!",
        redirectPath: "",
      });
    }
  };
  const handleCancel = () => {
    navigate(-1);
  };
  const handleVerify = () => {
    navigate("/user/exams/verifyMark", {
      state: {
        school_id: parseInt(school_id),
        staff_id: staff_id,
        CLASSID: CLASSID,
        SECTION: SECTION,
        SUBJECTID: SUBJECTID,
        EXAMNAME: EXAMNAME,
        MODEOFEXAM: MODEOFEXAM,
      },
    });
  };

  const handleSuccessOk = () => {
    const { type, redirectPath } = modalState;
    setModalState((prev) => ({
      ...prev,
      open: false,
    }));
    if (type === "success" && redirectPath) {
      navigate(redirectPath);
    }
  };
  return (
    <>
      <PopupModal
        open={modalState.open}
        title={modalState.type === "success" ? "Success" : "Failed"}
        message={modalState.message}
        onOk={handleSuccessOk}
      />
      <div className={styles.container}>
        <form className="row g-3 align-items-center">
          {/* Class */}
          <div className="col-lg-3 px-2 col-md-6 col-sm-12">
            <CustomDropdown
              label={translations.labels.class}
              name="classValue"
              value={classDetails.class_name}
              disabled
              placeholder={translations.labels.selectClass}
              isSearchable={false}
            />
          </div>

          {/* Section */}

          <div className="col-lg-3 px-2 col-md-6 col-sm-12">
            <CustomDropdown
              label={translations.labels.section}
              name="section"
              value={classDetails.section_id}
              placeholder={translations.labels.selectSection}
              disabled
              isSearchable={false}
            />
          </div>
          {/* Subject */}

          <div className="col-lg-3 px-2 col-md-6 col-sm-12">
            <CustomDropdown
              label={translations.labels.subject}
              name="subject"
              value={classDetails.subject_name}
              placeholder={translations.labels.selectsubjectPlaceholder}
              disabled
              isSearchable={false}
            />
          </div>

          {/* Exam Name */}
          <div className="col-lg-3 px-2 col-md-6 col-sm-12">
            <CustomDropdown
              label={translations.labels.examName || "Exam Name"}
              name="examName"
              value={classDetails.exam_name}
              placeholder={translations.labels.selectsubjectPlaceholder}
              disabled
              isSearchable={false}
            />
          </div>

          {/* Exam Mode */}
          <div className="col-lg-3 px-2 col-md-6 col-sm-12 mt-3">
            <CustomDropdown
              label={translations.labels.modeOfName || "Exam Mode"}
              name="modeOfName"
              value={classDetails.modeof_exam}
              placeholder={translations.labels.selectsubjectPlaceholder}
              disabled
              isSearchable={false}
            />
          </div>

          <>
            <div className="col-lg-3 col-md-6 col-sm-12 px-2">
              <CustomTextInput
                label={translations.labels.passMark || "Pass Mark"}
                value={classDetails.min_marks}
                disabled
              />
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 px-2">
              <CustomTextInput
                label={translations.labels.maxMark || "Max Makr"}
                value={classDetails.max_marks}
                disabled
              />
            </div>

            <div className="col-lg-3 col-md-6 col-sm-12 px-2">
              <CustomTextInput
                label={translations.labels.examDate || "Exam Date"}
                value={
                  classDetails?.exam_date
                    ? moment(classDetails.exam_date, "DD-MM-YYYY").format(
                        "DD/MM/YYYY",
                      )
                    : ""
                }
                disabled
              />
            </div>
          </>
<div className={styles.wrapper}>
    {examData.map((user, index) => (
        <div key={user.id} className={styles.card}>
            {/* Left Section */}
            <div className={styles.leftSection}>
                <div className={styles.avatarWrapper}>
                    <div
                        className={`${styles.avatar} 
                      ${user.is_top === 1 ? styles.topBorder : ""} 
                      ${user.is_fail === 1 ? styles.failBorder : ""}
                    `}
                    >
                        {user.student_profile ? (
                            <BlobImage
                                path={user.student_profile}
                                alt={user.name}
                                className={styles.profileImage}
                            />
                        ) : (
                            <FaUser className={styles.defaultIcon} />
                        )}
                    </div>
                    {user.is_top === 1 && <FaStar className={styles.topStar} />}
                </div>

                <div>
                    <div className={styles.phone}>{user.student_id}</div>
                    <div className={styles.name}>{user.name}</div>
                </div>
            </div>

            {/* Right Section */}
            <div className={styles.rightSection}>
                <input
                    type="number"
                    className={styles.markInput}
                    value={user.marks ?? ""}
                    onChange={(e) => handleMarkChange(user.student_id, e.target.value)}
                    min="0"
                    max={classDetails.max_marks}
                    step="1"
                />
            </div>
        </div>
    ))}
</div>
          <div className="col-md-12 pt-3">
            <div className={styles.buttonGroup}>
              <CustomButton
                variant="contained"
                onClick={handleDraft}
                className={styles.saveButton}
                loading={loading}
              >
                {translations.labels.updateButton || "Update"}
              </CustomButton>

              <CustomButton
                variant="contained"
                onClick={handleCancel}
                className={styles.cancelButton}
                disabled={loading}
              >
                {translations.labels.cancelButton}
              </CustomButton>
              <CustomButton
                variant="contained"
                onClick={handleVerify}
                // className={styles.cancelButton}
                disabled={loading}
              >
                {translations.labels.verifyButton || "Verify"}
              </CustomButton>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default ViewExamMarkEntry;
